import { render, staticRenderFns } from "./mealPlanStatisticsTable.vue?vue&type=template&id=9850f50a&scoped=true&"
import script from "./mealPlanStatisticsTable.vue?vue&type=script&lang=js&"
export * from "./mealPlanStatisticsTable.vue?vue&type=script&lang=js&"
import style0 from "./mealPlanStatisticsTable.vue?vue&type=style&index=0&id=9850f50a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9850f50a",
  null
  
)

export default component.exports